export default "__VITE_ASSET__JEo1ANIH__"